import type { SearchSuggestion } from '../view-models/search-suggestion';

/**
 * Type guard to check if a suggestion is a category suggestion
 * Categories have links but professionals are excluded (they have links starting with /professional/)
 */
export const isCategorySuggestion = (
    suggestion: SearchSuggestion | string,
): suggestion is SearchSuggestion => {
    return (
        typeof suggestion === 'object' &&
        'link' in suggestion &&
        !suggestion.link.startsWith('/professional/')
    );
};

/**
 * Type guard to check if a suggestion is a professional suggestion
 * Professionals have links starting with /professional/
 */
export const isProfessionalSuggestion = (
    suggestion: SearchSuggestion | string,
): suggestion is SearchSuggestion => {
    return (
        typeof suggestion === 'object' &&
        'link' in suggestion &&
        suggestion.link.startsWith('/professional/')
    );
};
